import React from 'react';
import './CoverLetter.css';
import PrtButton from './PrtButton';

function CoverLetter() {
  return (
    <div className="cover-letter">
      <header>
        <PrtButton label="Print Page" />

        <h1>Cover Letter</h1>
        <p className="contact">
          <a href="mailto:joeitguy@gmail.com">joeitguy@gmail.com</a> • (619) 438-3236 • <a href="https://linkedin.com/in/joeitguy">LinkedIn</a>
        </p>
      </header>

      <section className="letter-body">
        <p>2026</p>

        <p>Dear Hiring Team,</p>

        <p>
          I'm writing to introduce myself as a data professional who thrives at the intersection of
          technology, teamwork, and problem-solving. My career has been built around connecting
          systems, people, and ideas — turning scattered data into clear, reliable insight. Whether I'm
          designing an ETL pipeline, debugging a stubborn SQL query, or helping a team visualize their
          metrics, I bring a steady, collaborative approach that keeps projects moving forward.
        </p>

        <p>
          Over the years, I've worked across SQL Server, Postgres, and Python environments, building
          automated reporting workflows and integration solutions that make data accessible and
          actionable. I enjoy the challenge of translating technical complexity into something meaningful
          for business users — it's where my analytical mindset meets my communication skills.
        </p>

        <p>
          My foundation in the U.S. Navy taught me discipline, consistency, and the value of trust within
          a team. Those lessons still guide how I work today: stay calm under pressure, communicate
          clearly, and deliver with integrity. I take pride in being the person who keeps systems talking
          and teams aligned, no matter how complex the environment.
        </p>

        <p>
          I'm drawn to organizations that value innovation and collaboration in the Data & Technology
          ecosystem. I'd welcome the chance to bring my technical depth, reliability, and team-first
          mindset to your projects.
        </p>

        <p>
          Thank you for your time and consideration. I look forward to connecting and learning more
          about how I can support your mission.
        </p>

        <p className="closing">
          Respectfully,<br />
          Joseph William Phillip Bodden Jr.<br />
          Poway, CA<br />
          (619) 438-3236 • <a href="mailto:joeitguy@gmail.com">joeitguy@gmail.com</a>
        </p>
      </section>
    </div>
  );
}

export default CoverLetter;
